export default "/images/vendor/flag-icon-css/flags/4x3/eu.svg?db2e50ad0bf5ecccc0caf01d1556a162";